<template>
  <div class="image-box" @click="onBoxClick">
    <van-icon class="icon-tip" size="27" name="photo-o" />
    <span>{{ desc }}</span>
  </div>
</template>
<script>
export default {
  props: {
    desc: {
      type: String,
      default: '上传图片'
    }
  },
  methods: {
    onBoxClick() {
      this.$emit('onImageBtnClick');
    }
  }
};
</script>
<style lang="less" scoped>
.image-box {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f6f6f6;
  span {
    color: #adadad;
    font-size: 14px;
  }
  .icon-tip {
    color: #adadad;
    margin-bottom: 6px;
  }
  .delete-btn {
    width: 15px;
    height: 15px;
    background: rgba(0, 0, 0, 0.7);
    top: 0;
    right: 0;
  }
}
</style>
